import React from "react";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { interest } from "../redux/actions/auth.actions";
import ListErrors from "../components/ListErrors";
import { Link } from "react-router-dom";
import { Translation } from "react-i18next";
import i18n from "../languages/lang.js";

const InterestSchema = Yup.object().shape({
  firstname: Yup.string()
    .min(2, i18n.t("auth.from_firstname_invalid_error"))
    .required(i18n.t("auth.form_firstname_required_error")),
  lastname: Yup.string()
    .min(2, i18n.t("auth.from_lastname_invalid_error  "))
    .required(i18n.t("auth.form_lastname_required_error")),
  email: Yup.string()
    .email(i18n.t("auth.form_email_invalid_error"))
    .required(i18n.t("auth.form_email_required_error"))
});

function Interest() {
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const handleSubmit = (firstname, lastname, email) =>
    dispatch(interest(firstname, lastname, email));

  return (
    <Translation>
      {t => (
        <div id="focus">
          <div id="focus-header">
            <h1>{t("system.project_name")}</h1>
          </div>
          <div className="main">
            <div className="main-wrap">
              <div className="focus-wrap">
                <h2>{t("auth.interest_title")}</h2>
                <Formik
                  initialValues={{
                    firstname: "",
                    lastname: "",
                    email: ""
                  }}
                  validationSchema={InterestSchema}
                  onSubmit={(payload, { setSubmitting }) => {
                    // alert(payload.email)
                    handleSubmit(
                      payload.firstname,
                      payload.lastname,
                      payload.email
                    );
                    setSubmitting(false);
                  }}
                >
                  {({ touched, errors, isSubmitting }) => (
                    <Form>
                      <div className={`form-item`}>
                        <label htmlFor="firstname">
                          {t("auth.label_firstname")}
                        </label>
                        <Field
                          name="firstname"
                          type="text"
                          placeholder={t("auth.input_firstname_placeholder")}
                        />
                        <ErrorMessage
                          name="firstname"
                          className="error-message"
                          component="div"
                        />
                      </div>
                      <div className={`form-item`}>
                        <label htmlFor="lastname">
                          {t("auth.label_lastname")}
                        </label>
                        <Field
                          name="lastname"
                          type="text"
                          placeholder={t("auth.input_lastname_placeholder")}
                        />
                        <ErrorMessage
                          name="lastname"
                          className="error-message"
                          component="div"
                        />
                      </div>
                      <div className={`form-item`}>
                        <label htmlFor="email">{t("auth.label_email")}</label>
                        <Field
                          name="email"
                          type="email"
                          placeholder={t("auth.input_email_placeholder")}
                        />
                        <ErrorMessage
                          name="email"
                          className="error-message"
                          component="div"
                        />
                      </div>
                      <ListErrors errors={auth.errors} />
                      <div className="form-item">
                        <button type="submit" disabled={isSubmitting}>
                          {isSubmitting
                            ? t("system.submitting_feeback")
                            : t("auth.interest_button")}
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
            {auth.interset_resp && auth.interset_resp.result === "OK" ? (
              <div className="main-wrap">
                <div className="focus-wrap">
                  <div className="form-item">
                    {t("auth.interest_success_msg")}
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      )}
    </Translation>
  );
}

export default Interest;
